import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
const fadeInUp = {
  initial: {
    opacity: 0,
    y: 24
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true,
    margin: '-60px'
  },
  transition: {
    duration: 0.5,
    ease: 'easeOut'
  }
};
export function ForWhomSection() {
  return <section className="w-full px-5 py-16 md:py-24 bg-[#F5F0EA]" data-id="element-104">
      <div className="max-w-3xl mx-auto" data-id="element-105">
        <motion.h2 {...fadeInUp} className="text-2xl md:text-4xl font-semibold text-[#2C2825] mb-12 text-center" data-id="element-106">
          ¿Es para ti?
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-107">
          {/* For */}
          <motion.div {...fadeInUp} transition={{
          ...fadeInUp.transition,
          delay: 0.05
        }} className="bg-white rounded-xl p-6 border border-[#B8A99A]/15" data-id="element-108">
            <h3 className="text-lg font-semibold text-[#2C2825] mb-5" style={{
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-109">
              Es para ti si…
            </h3>
            <ul className="space-y-4" data-id="element-110">
              <li className="flex items-start gap-3" data-id="element-111">
                <span className="mt-0.5 flex-shrink-0 w-5 h-5 rounded-full bg-green-100 flex items-center justify-center" data-id="element-112">
                  <CheckIcon className="w-3 h-3 text-green-600" data-id="element-113" />
                </span>
                <span className="text-[#2C2825]/75 text-sm leading-relaxed" data-id="element-114">
                  Llevas tiempo luchando con tus ojeras y nada parece funcionar
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-115">
                <span className="mt-0.5 flex-shrink-0 w-5 h-5 rounded-full bg-green-100 flex items-center justify-center" data-id="element-116">
                  <CheckIcon className="w-3 h-3 text-green-600" data-id="element-117" />
                </span>
                <span className="text-[#2C2825]/75 text-sm leading-relaxed" data-id="element-118">
                  Quieres entender qué tipo de ojera tienes antes de gastar más
                  dinero
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-119">
                <span className="mt-0.5 flex-shrink-0 w-5 h-5 rounded-full bg-green-100 flex items-center justify-center" data-id="element-120">
                  <CheckIcon className="w-3 h-3 text-green-600" data-id="element-121" />
                </span>
                <span className="text-[#2C2825]/75 text-sm leading-relaxed" data-id="element-122">
                  Buscas una rutina sencilla que puedas seguir sin complicarte
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-123">
                <span className="mt-0.5 flex-shrink-0 w-5 h-5 rounded-full bg-green-100 flex items-center justify-center" data-id="element-124">
                  <CheckIcon className="w-3 h-3 text-green-600" data-id="element-125" />
                </span>
                <span className="text-[#2C2825]/75 text-sm leading-relaxed" data-id="element-126">
                  Te gustaría verte más descansada en el espejo y en las fotos
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-127">
                <span className="mt-0.5 flex-shrink-0 w-5 h-5 rounded-full bg-green-100 flex items-center justify-center" data-id="element-128">
                  <CheckIcon className="w-3 h-3 text-green-600" data-id="element-129" />
                </span>
                <span className="text-[#2C2825]/75 text-sm leading-relaxed" data-id="element-130">
                  Valoras tener un plan claro en vez de probar cosas al azar
                </span>
              </li>
            </ul>
          </motion.div>

          {/* Not for */}
          <motion.div {...fadeInUp} transition={{
          ...fadeInUp.transition,
          delay: 0.1
        }} className="bg-white rounded-xl p-6 border border-[#B8A99A]/15" data-id="element-131">
            <h3 className="text-lg font-semibold text-[#2C2825] mb-5" style={{
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-132">
              No es para ti si…
            </h3>
            <ul className="space-y-4" data-id="element-133">
              <li className="flex items-start gap-3" data-id="element-134">
                <span className="mt-0.5 flex-shrink-0 w-5 h-5 rounded-full bg-red-50 flex items-center justify-center" data-id="element-135">
                  <XIcon className="w-3 h-3 text-red-400" data-id="element-136" />
                </span>
                <span className="text-[#2C2825]/75 text-sm leading-relaxed" data-id="element-137">
                  Buscas una solución médica o un tratamiento clínico
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-138">
                <span className="mt-0.5 flex-shrink-0 w-5 h-5 rounded-full bg-red-50 flex items-center justify-center" data-id="element-139">
                  <XIcon className="w-3 h-3 text-red-400" data-id="element-140" />
                </span>
                <span className="text-[#2C2825]/75 text-sm leading-relaxed" data-id="element-141">
                  Esperas resultados mágicos sin seguir ninguna rutina
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-142">
                <span className="mt-0.5 flex-shrink-0 w-5 h-5 rounded-full bg-red-50 flex items-center justify-center" data-id="element-143">
                  <XIcon className="w-3 h-3 text-red-400" data-id="element-144" />
                </span>
                <span className="text-[#2C2825]/75 text-sm leading-relaxed" data-id="element-145">
                  No estás dispuesta a dedicar 5 minutos al día durante 7 días
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-146">
                <span className="mt-0.5 flex-shrink-0 w-5 h-5 rounded-full bg-red-50 flex items-center justify-center" data-id="element-147">
                  <XIcon className="w-3 h-3 text-red-400" data-id="element-148" />
                </span>
                <span className="text-[#2C2825]/75 text-sm leading-relaxed" data-id="element-149">
                  Prefieres seguir probando productos sin saber tu tipo de ojera
                </span>
              </li>
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}